/**
 * @ngdoc directive
 * @name cbl.insuranceloanpmi.mf.directive:creasSceltaPolizze
 * @restrict E
 * @description Componente che gestisce il secondo sotto-step "Scelta Polizze" dello step "Pagamento"
 */
(function() {
	"use strict";
	var CreasSceltaPolizzeCtrl = function($http, $scope, $state, $stateParams, $window, $q, $httpParamSerializer, CONSTANTS, labelSrvc, messaggiFctr, dettPraticaSrvc) {
		this.$http = $http;
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.$window = $window;
		this.messaggiFctr = messaggiFctr;
		this.dettPraticaSrvc = dettPraticaSrvc;
		this.CONSTANTS = CONSTANTS;
		$scope.msg = labelSrvc.getLabel;
		
		// Spinner
	    this.spinner = this.dettPraticaSrvc.spinner;
		this.subSpinner = {
			ricerca: false
		}
		
		this.numeroTitolo = null;
		
		this.compagnie = [
			{ id: 1, descrizione: 'Reale Mutua' },
			{ id: 3, descrizione: 'Italiana Assicurazioni' }
		];
		this.compagnia = null;
		
		this.titoliCercati = [];
		this.titoloSelezionato = null;
		
		var self = this;
		
		// Configuro l'abilitazione dei pulsanti di scorrimento tra gli step	
		dettPraticaSrvc.isCancelFinanziamentoVisible = function() {
	      return true;
	    };
	    dettPraticaSrvc.isCancelFinanziamentoEnabled = function() {
	      return true;
	    };
		dettPraticaSrvc.isSaveEnabled = function() {
			return self.dettPraticaSrvc.finanziamento && self.dettPraticaSrvc.finanziamento.elencoPolizze && self.dettPraticaSrvc.finanziamento.elencoPolizze.length > 0;
		}
		
		dettPraticaSrvc.isPrevEnabled = function() {
			return true;
		}
		
		dettPraticaSrvc.isNextEnabled = function() {
			return self.dettPraticaSrvc.finanziamento && self.dettPraticaSrvc.finanziamento.elencoPolizze && self.dettPraticaSrvc.finanziamento.elencoPolizze.length > 0;
		}
		
		// Configuro il comportamento del pulsante prosegui per lo step
	    dettPraticaSrvc.nextStep = function() {
	    	
	    	if (self.dettPraticaSrvc.verificaImportiPolizze() !== true) {
				return;
			}
	    	
			self.spinner.pratica = true;
			  
			// SALVATAGGIO POLIZZE
			$q
			.all({salvaPolizze: self.dettPraticaSrvc.promiseSalvaPolizze()})
			.then(
			  function(response) {
				  if (self.messaggiFctr.processaResponse(response.salvaPolizze)) {
					  self.spinner.pratica = false;
            		  return;
            	  }
				  
				  if (response.salvaPolizze.data.result) {
		            $q
		              .all({
		                nextStep: self.dettPraticaSrvc.promiseCambiaStep('/avantiStep')
		              })
		              .then(
		                function(response) {
	                	  if (self.messaggiFctr.processaResponse(response.nextStep)) {
	                		  return;
	                	  }
	                	  
		                  self.dettPraticaSrvc.datiPratica = response.nextStep.data.result;
		                  self.dettPraticaSrvc.generaTabs();
		                },
		                function(reason) {
		                  self.messaggiFctr.processaResponse(reason.nextStep);
		                }
		              )
		              .finally(function() {
		                self.spinner.pratica = false;
		              });
		          } else {
		            self.spinner.pratica = false;
		          }
			  },
			  function(reason) {
			    self.messaggiFctr.processaResponse(reason.salvaPolizze);
			    self.spinner.pratica = false;
			  }
			);
	    	
	    };

	    // Configuro il comportamento del pulsante salva per lo step
		dettPraticaSrvc.salva = function() {
			
			if (self.dettPraticaSrvc.verificaImportiPolizze() !== true) {
				return;
			}
				
			self.spinner.pratica = true;
			  
			$q
			.all({salvaPolizze: self.dettPraticaSrvc.promiseSalvaPolizze()})
			.then(
				function(response) {
					self.dettPraticaSrvc.finanziamento = response.salvaPolizze.data.result;
					if (self.messaggiFctr.processaResponse(response.salvaPolizze)) {
						return;
					}
				},
				function(reason) {
					self.messaggiFctr.processaResponse(reason.salvaPolizze);
				}
			)
			.finally(function() {
				self.spinner.pratica = false;
			});
		
		};
		
		/**
		 * @ngdoc method
		 * @name promiseTitoli
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasSceltaPolizze
		 * @description Effettua una chiamata http che recupera un titolo in base al numero specificato
		 * @return {Promise} - Ritorna una promise contenente il titolo cercato
		 */
		this.promiseTitoli = function() {
			
			var queryParamsObj = {
				numTitolo: self.numeroTitolo,
				codiceCompagnia: self.compagnia
			};
			
			var queryParams = $httpParamSerializer(queryParamsObj);
			
			return this.$http({
				method: 'GET',
				url: CONSTANTS.REST_ROOT + CONSTANTS.REST.TITOLI + '?' + queryParams
			});
		}
		
		/**
		 * @ngdoc method
		 * @name recuperaTitoli
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasSceltaPolizze
		 * @description Esegue la ricerca degli utilizzi inerenti l'affidamento
		 */
		this.recuperaTitoli = function() {
			
			// FIXME: rimuovere o impostare a false!
			if (false) {
				self.titoliCercati = [
					{"idDatiPagamento":null,"codiceIncasso":"182060000000076712","dataPagamento":1416870000000,"scadenzaCopertura":1340143200000,"importoPremioLordo":104.00,"codiceDivisa":"EUR","codiceCompagnia":"3","codiceAgenzia":"838","codiceRamo":"08","numeroPolizza":"2011086086200","nominativoContraente":"D'ALESSANDRO FRANCESCO","tipoModello":"00019","descrizioneModello":"PROTEZIONE  9","intestazioneCCAgente":"DE LEO  S.N.C. DI DE LEO CANDELORO","ibanStatoAgente":"","cinEUAgente":null,"cinITAgente":"","abiAgente":"01020","cabAgente":"04605","contoCorrenteAgente":"000300488537"},
					{"idDatiPagamento":null,"codiceIncasso":"182060000000076713","dataPagamento":1416870000000,"scadenzaCopertura":1340143200000,"importoPremioLordo":105.00,"codiceDivisa":"EUR","codiceCompagnia":"3","codiceAgenzia":"838","codiceRamo":"08","numeroPolizza":"2011086086201","nominativoContraente":"D'ALESSANDRO FRANCESCO","tipoModello":"00019","descrizioneModello":"PROTEZIONE  9","intestazioneCCAgente":"DE LEO  S.N.C. DI DE LEO CANDELORO","ibanStatoAgente":"","cinEUAgente":null,"cinITAgente":"","abiAgente":"01020","cabAgente":"04605","contoCorrenteAgente":"000300488537"},
					{"idDatiPagamento":null,"codiceIncasso":"182060000000076714","dataPagamento":1416870000000,"scadenzaCopertura":1340143200000,"importoPremioLordo":106.00,"codiceDivisa":"EUR","codiceCompagnia":"3","codiceAgenzia":"838","codiceRamo":"08","numeroPolizza":"2011086086202","nominativoContraente":"D'ALESSANDRO FRANCESCO","tipoModello":"00019","descrizioneModello":"PROTEZIONE  9","intestazioneCCAgente":"DE LEO  S.N.C. DI DE LEO CANDELORO","ibanStatoAgente":"","cinEUAgente":null,"cinITAgente":"","abiAgente":"01020","cabAgente":"04606","contoCorrenteAgente":"000300488539"}
				];
				return;
			}
			
			if (!self.numeroTitolo) {
				return;
			}
			
			if (!self.compagnia) {
				return;
			}
			
			if (self.numeroTitolo && self.numeroTitolo.trim() === '') {
				return;
			}
			
			self.subSpinner.ricerca = true;
			
			$q.all({
				titoli: self.promiseTitoli(),
			}).then(function(response) {
				
				if (self.messaggiFctr.processaResponse(response.titoli)) {
					self.titoliCercati = [];
					return;
				}
				
				if (self.titoloGiaAggiunto(response.titoli.data.result) === true) {
					self.titoliCercati = [];
					return;
				}
				
				self.titoliCercati = [ response.titoli.data.result ];
			}, function(reason) {
	    		self.messaggiFctr.processaResponse(reason.titoli);
	    		self.polizzeCercate = [];
			}).finally(function() {
				self.subSpinner.ricerca = false;
			});
			
		}
		
		/**
		 * @ngdoc method
		 * @name titoloGiaAggiunto
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasSceltaPolizze
		 * @description Verifica se il titolo specificato è già stato aggiunto alla pratica
		 * @param {Object} titolo - Il titolo da verificare
		 * @return {boolean} - Ritorna true se il titolo è già aggiunto, false se non è presente tra gli aggiunti
		 */
		this.titoloGiaAggiunto = function(titolo) {
			if (!self.dettPraticaSrvc.finanziamento) {
				return false;
			}
			
			if (!self.dettPraticaSrvc.finanziamento.elencoPolizze) {
				return false;
			}
			
			var titoliPresenti = self.dettPraticaSrvc.finanziamento.elencoPolizze.filter(function(ttl) {
				return ttl.datiPagamento.codiceIncasso === titolo.codiceIncasso;
			});
			
			return titoliPresenti.length > 0;
		}
		
		/**
		 * @ngdoc method
		 * @name titoloInAggiunta
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasSceltaPolizze
		 * @description Verifica se il titolo specificato è in fase di aggiunta nella pratica
		 * @param {Object} titolo - Il titolo da verificare
		 * @return {boolean} - Ritorna true se il titolo è in fase di aggiunta, false in caso contrario
		 */
		this.titoloInAggiunta = function(titolo) {
			if (!self.titoloSelezionato) {
				return false;
			}
			
			return self.titoloSelezionato.codiceIncasso === titolo.codiceIncasso;
		}
		
		/**
		 * @ngdoc method
		 * @name aggiungiTitolo
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasSceltaPolizze
		 * @description Aggiunge, se non è già presente, il titolo alla pratica
		 * @param {Object} titolo - Il titolo da aggiungere
		 */
		this.aggiungiTitolo = function(titolo) {
			if (self.titoloGiaAggiunto(titolo) === true) {
				self.messaggiFctr.addMessage({ type: 'W', message: $scope.msg('label.dettagliopratica.step6.sub2.titologiaaggiunto') });
				return;
			}
			
			var tmpTitolo = angular.copy(titolo);
			
			// Se ho delle polizze selezionate, verifico che quella che sto aggiungendo abbia il solito iban
			// Se non ho polizze selezionate, mostro il passaggio intermedio per richiedere cinEUAgente e cinITAgente
			var datiIBANPolizze = self.recuperaIBANPolizze();
			
			if (!datiIBANPolizze) {				
				if (!tmpTitolo.ibanStatoAgente || (tmpTitolo.ibanStatoAgente && tmpTitolo.ibanStatoAgente.trim() === '')) {
					tmpTitolo.ibanStatoAgente = 'IT';
				}
				
				self.titoloSelezionato = tmpTitolo;
				return;
			}
			
			var noStatoIban = false;
			if (!tmpTitolo.ibanStatoAgente || (tmpTitolo.ibanStatoAgente && tmpTitolo.ibanStatoAgente.trim() === '')) {
				noStatoIban = true;
				tmpTitolo.ibanStatoAgente = 'IT';
			}
			
			if (
				datiIBANPolizze.ibanStatoAgente !== tmpTitolo.ibanStatoAgente ||
				datiIBANPolizze.abiAgente !== tmpTitolo.abiAgente ||
				datiIBANPolizze.cabAgente !== tmpTitolo.cabAgente ||
				datiIBANPolizze.contoCorrenteAgente !== tmpTitolo.contoCorrenteAgente
			) {
				if (noStatoIban === true) {
					tmpTitolo.ibanStatoAgente = '';
				}
				
				self.messaggiFctr.addMessage({ type: 'W', message: $scope.msg('label.dettagliopratica.step6.sub2.ibannoncorrisp') });
				return;
			}
			
			// Se i dati dell'IBAN corrispondono, aggiungo il titolo direttamente assegnando cin EU e cin IT
			tmpTitolo.cinEUAgente = datiIBANPolizze.cinEUAgente;
			tmpTitolo.cinITAgente = datiIBANPolizze.cinITAgente;
			
			var polizza = {
				idFinanziamentoMultiPolizzaPMI: self.dettPraticaSrvc.finanziamento.idFinanziamentoMultiPolizzaPMI,
			    numeroPolizza: tmpTitolo.numeroPolizza,
			    importoPremio: tmpTitolo.importoPremioLordo,
			    preventivo: false,
			    descrizionePolizza: tmpTitolo.descrizioneModello,
			    datiPagamento: tmpTitolo
			};
			
			if (!self.dettPraticaSrvc.finanziamento.elencoPolizze) {
				self.dettPraticaSrvc.finanziamento.elencoPolizze = [];
			}
			
			self.dettPraticaSrvc.finanziamento.elencoPolizze.push(polizza);
			self.aggiornaTitoli();
		}
		
		/**
		 * @ngdoc method
		 * @name recuperaIBANPolizze
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasSceltaPolizze
		 * @description Recupera i dati dell'IBAN di accredito per le polizze selezionate
		 * @return {Object} Struttura contenente i dati dell'IBAN delle polizze selezionate
		 */
		this.recuperaIBANPolizze = function() {
			if (!self.dettPraticaSrvc.finanziamento) {
				return null;
			}
			
			if (!self.dettPraticaSrvc.finanziamento.elencoPolizze) {
				return null;
			}
			
			if (self.dettPraticaSrvc.finanziamento.elencoPolizze.length === 0) {
				return null;
			}
			
			return {
				ibanStatoAgente: self.dettPraticaSrvc.finanziamento.elencoPolizze[0].datiPagamento.ibanStatoAgente,
				cinEUAgente: self.dettPraticaSrvc.finanziamento.elencoPolizze[0].datiPagamento.cinEUAgente,
				cinITAgente: self.dettPraticaSrvc.finanziamento.elencoPolizze[0].datiPagamento.cinITAgente,
				abiAgente: self.dettPraticaSrvc.finanziamento.elencoPolizze[0].datiPagamento.abiAgente,
				cabAgente: self.dettPraticaSrvc.finanziamento.elencoPolizze[0].datiPagamento.cabAgente,
				contoCorrenteAgente: self.dettPraticaSrvc.finanziamento.elencoPolizze[0].datiPagamento.contoCorrenteAgente
			};
		}
		
		/**
		 * @ngdoc method
		 * @name confermaTitoloSelezionato
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasSceltaPolizze
		 * @description Conferma l'aggiunta del titolo selezionato e per il quale si stanno compilando i dati
		 */
		this.confermaTitoloSelezionato = function() {
			
			if (!self.titoloSelezionato) {
				return;
			}
			
			// CONTROLLI CIN EU
			if (!self.titoloSelezionato.cinEUAgente || (self.titoloSelezionato.cinEUAgente && self.titoloSelezionato.cinEUAgente.trim() === '')) {
				self.messaggiFctr.addMessage({ type: 'W', message: $scope.msg('label.dettagliopratica.step6.sub2.invalidcineu') });
				return;
			}
			
			if (self.titoloSelezionato.cinEUAgente.trim().length !== 2) {
				self.messaggiFctr.addMessage({ type: 'W', message: $scope.msg('label.dettagliopratica.step6.sub2.invalidcineu') });
				return;
			}
			
			if (!(/^\d+$/.test(self.titoloSelezionato.cinEUAgente.trim()))) {
				self.messaggiFctr.addMessage({ type: 'W', message: $scope.msg('label.dettagliopratica.step6.sub2.invalidcineu') });
				return;
			}
			
			// CONTROLLI CIN IT
			if (!self.titoloSelezionato.cinITAgente || (self.titoloSelezionato.cinITAgente && self.titoloSelezionato.cinITAgente.trim() === '')) {
				self.messaggiFctr.addMessage({ type: 'W', message: $scope.msg('label.dettagliopratica.step6.sub2.invalidcinit') });
				return;
			}
			
			if (self.titoloSelezionato.cinITAgente.trim().length !== 1) {
				self.messaggiFctr.addMessage({ type: 'W', message: $scope.msg('label.dettagliopratica.step6.sub2.invalidcinit') });
				return;
			}
			
			if (!(/^[a-zA-Z]$/.test(self.titoloSelezionato.cinITAgente.trim()))) {
				self.messaggiFctr.addMessage({ type: 'W', message: $scope.msg('label.dettagliopratica.step6.sub2.invalidcinit') });
				return;
			}
			
			self.titoloSelezionato.cinITAgente = self.titoloSelezionato.cinITAgente.toUpperCase();
			
			// SALVO LA POLIZZA CON L'IBAN
			var polizza = {
				idFinanziamentoMultiPolizzaPMI: self.dettPraticaSrvc.finanziamento.idFinanziamentoMultiPolizzaPMI,
			    numeroPolizza: self.titoloSelezionato.numeroPolizza,
			    importoPremio: self.titoloSelezionato.importoPremioLordo,
			    descrizionePolizza: self.titoloSelezionato.descrizioneModello,
			    preventivo: false,
			    datiPagamento: self.titoloSelezionato
			};
			
			if (!self.dettPraticaSrvc.finanziamento.elencoPolizze) {
				self.dettPraticaSrvc.finanziamento.elencoPolizze = [];
			}
			
			self.dettPraticaSrvc.finanziamento.elencoPolizze.push(polizza);
			self.aggiornaTitoli();
			self.titoloSelezionato = null;
		}
		
		/**
		 * @ngdoc method
		 * @name annullaTitoloSelezionato
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasSceltaPolizze
		 * @description Annulla l'aggiunta del titolo selezionato per il quale si stanno compilando i dati
		 */
		this.annullaTitoloSelezionato = function() {
			self.aggiornaTitoli();
			self.titoloSelezionato = null;
		}
		
		/**
		 * @ngdoc method
		 * @name rimuoviTitolo
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasSceltaPolizze
		 * @description Rimuove il titolo selezionato da quelli aggiunti alla pratica
		 * @param {Object} titolo - Il titolo da rimuovere
		 */
		this.rimuoviTitolo = function(titolo) {
			var itemIndex = self.dettPraticaSrvc.finanziamento.elencoPolizze.indexOf(titolo);
			
			if (itemIndex === -1) {
				return;
			}
			
			self.dettPraticaSrvc.finanziamento.elencoPolizze.splice(itemIndex, 1);
			self.aggiornaTitoli();
		}
		
		/**
		 * @ngdoc method
		 * @name aggiornaTitoli
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasSceltaPolizze
		 * @description Aggiorna la visualizzazione degli elenchi di titoli cercati e aggiunti
		 */
		this.aggiornaTitoli = function() {
			self.titoliCercati = self.titoliCercati.concat([]);
			
			if (self.dettPraticaSrvc.finanziamento && self.dettPraticaSrvc.finanziamento.elencoPolizze) {				
				self.dettPraticaSrvc.finanziamento.elencoPolizze = self.dettPraticaSrvc.finanziamento.elencoPolizze.concat([]);
			}
		}
		
		/**
		 * @ngdoc method
		 * @name recuperaTotaleTitoli
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasSceltaPolizze
		 * @description Calcola e mostra il totale dei titoli selezionati
		 */
		this.recuperaTotaleTitoli = function() {			
			var totaleTitoli = 0;
			
			if (self.dettPraticaSrvc.finanziamento.elencoPolizze && self.dettPraticaSrvc.finanziamento.elencoPolizze.length > 0) {
				for(var i = 0; i < self.dettPraticaSrvc.finanziamento.elencoPolizze.length; i++) {
					totaleTitoli += self.dettPraticaSrvc.finanziamento.elencoPolizze[i].datiPagamento.importoPremioLordo;
				}
			}
			
			return totaleTitoli;
		}
		
		/**
		 * @ngdoc method
		 * @name mostraTitoliSalvati
		 * @methodOf cbl.insuranceloanpmi.mf.directive:creasSceltaPolizze
		 * @description Recupera i titoli salvati nella pratica e li mostra tra quelli selezionati
		 */
		this.mostraTitoliSalvati = function() {
			self.dettPraticaSrvc.finanziamento = self.dettPraticaSrvc.getFinanziamentoBozza();
			
			if (!self.dettPraticaSrvc.finanziamento) {
				return;
			}
			
			if (!self.dettPraticaSrvc.finanziamento.elencoPolizze) {
				return;
			}

			self.aggiornaTitoli();
		}
		
		this.mostraTitoliSalvati();

	};

	CreasSceltaPolizzeCtrl.$inject = [ '$http', '$scope', '$state', '$stateParams', '$window', '$q', '$httpParamSerializer', 'CONSTANTS', 'LabelSrvc', 'CreasMessaggiFctr', 'CreasDettaglioPraticaSrvc' ];

	var TemplateUrl = function(CONSTANTS) {
		return CONSTANTS.BASE_ROOT + CONSTANTS.COMPONENTS_PATH + "creasDettaglioPratica/creasPraticaPagamento/creasSceltaPolizze/creasSceltaPolizze.html";
	}

	TemplateUrl.$inject = [ 'CONSTANTS' ];

	var CreasSceltaPolizzeComponent = {
		bindings : {},
		controller : CreasSceltaPolizzeCtrl,
		controllerAs : "creasSceltaPolizzeCtrl",
		templateUrl : TemplateUrl
	};

	angular.module("cbl.insuranceloanpmi.mf").component("creasSceltaPolizze", CreasSceltaPolizzeComponent);
}());


//////////////////
// WEBPACK FOOTER
// ./app/components/creasDettaglioPratica/creasPraticaPagamento/creasSceltaPolizze/creasSceltaPolizze.cmpt.js
// module id = 28
// module chunks = 0 1